import React from 'react';
import { GridTable } from '@ctsu/ctsu-mui-grid';
import { openConfirmation } from 'helpers/Confirmation';
import { openSnackbar } from 'helpers/Notifier';
// import { CanUserEditCountries } from 'appconstants/Permission';
import { GetFromCtxValue, GetUserFullName, useGetPathProtocol } from 'helpers';
import { httpStatusEnum , TE } from 'appconstants';
import { withAppContext } from '@ctsu/loader';
import { compose, withHandlers, withState } from 'recompose';
import { withStyles } from '@material-ui/core/styles';
import { ValidatorForm } from 'components/FormHelpers/FormInputs';
import { bindLogger } from 'helpers/BindLogger';
import _ from 'lodash';
import { saveParticipantCountries } from 'actions/protocols/participation';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { PartCountriesColumns } from '../gridcolumns';
import EditParticipationCountries from './EditParticipationCountries';

const styles = theme => ({
  tableHeader: {},
  tableHeaderCell: {
    paddingRight: '4px',
    paddingLeft: '4px'
  },
  select: {
    marginTop: 10
  }
});


let setEditingFlag;

const dummyRow = {
  participationDate: '',
  participationEndDate: '',
  regulatoryHolder: '',
  regulatoryRqmt: '',
  code: null
};
export const ParticipationCountriesContainer = (props) => {
  const {
    participatingCountries,
    participationInfo,
    saveCountries,
    setState,
    state,
    CanUserEditCountries
  } = props;

  const protocolNumber = useGetPathProtocol();

  const saveCountry = () => {
    saveCountries(state);
  };

  const RenderEditRow = (row, setEditing) => {
    let defaultRow = {...row};
    if (_.isEmpty(row)) {
      defaultRow = { ...dummyRow };
    }
    if (state?.code == null && !_.isEqual(defaultRow, state)) {
      setState({ ...defaultRow });
    }

    setEditingFlag = (flg) => {
      setEditing(flg);
      setState(defaultRow);
    };
    return (
      <EditParticipationCountries
        state={state || defaultRow}
        setEditing={setEditing}
        defaultRow={defaultRow}
        participationInfo={participationInfo}
        setState={setState}
      />
    );
  };
  return (
    <ValidatorForm onSubmit={saveCountry}>
      <GridTable
        tag={`${TE.ID}indcountries${TE.TABLE}`}
        title="Countries"
        exportTitle={`Countries-${protocolNumber}-Participation`}
        id="indAgents"
        columns={PartCountriesColumns}
        user={GetUserFullName()}
        rows={participatingCountries}
        editable
        editMode={CanUserEditCountries}
        // deletable
        allowAddRow
        filterable
        sortable
        enableToolbar
        renderEditRow={RenderEditRow}
        rowEditable={(row) => CanUserEditCountries}
        toPdf={false}
        // rowDeletable={() => true}
      />
    </ValidatorForm>
  );
};

const withConnectState = connect(
  (state, ownProps) => ({}),
  dispatch => bindActionCreators({
    onSaveCountries: saveParticipantCountries
  }, dispatch)
);

const ParticipationCountries = withStyles(styles)(compose(
  withAppContext,
  withConnectState,
  withState('state', 'setState', {...dummyRow}),
  withHandlers({
    saveCountries: props => postBody => {
      const {
        protocolId, onSaveCountries, context, setState
      } = props;
      const confirmSave = () => {
        bindLogger(onSaveCountries, context)(protocolId,
          { ...postBody, prtId: protocolId, participationFlag: 'ALL' }).subscribe(resp => {
          if (resp.status === httpStatusEnum.SUCCESS) {
            openSnackbar({
              message: GetFromCtxValue(context, 'PROTOCOL_PARTICIPATION_COUNTRIES_SUCCESS'),
              variant: 'success',
              name: 'participation_countries'
            });
            setEditingFlag(false);
            setState({ ...dummyRow });
          }
        });
      };
      openConfirmation({
        message: GetFromCtxValue(context, postBody.participationEndDate ? 'PROTOCOL_PARTICIPATION_COUNTRIES_END_DATE_CONFIRM' : 'PROTOCOL_PARTICIPATION_COUNTRIES_CONFIRM'),
        onAction: confirmSave,
        name: 'end_date_check'
      });
    }
  })
)(ParticipationCountriesContainer));

export default ParticipationCountries;
